











































































































































































































import Vue from "vue";
import { mapState, mapActions } from "vuex";
import { getHumanReadableTimeDifference } from "@/utils";
import AIcon from "@canvas/componentlibrary/src/newcanvascomponents/AIcon.vue";
export default Vue.extend({
  name: "customer-details",
  data() {
    return {
      viewMoreTextHint: false,
    };
  },
  computed: {
    ...mapState("uiModule", {
      isOnMobileDevice: "isOnMobileDevice",
    }),
    ...mapState("appModule", {
      projectTypes: "projectTypes",
    }),
    ...mapState("appModule", {
      projectTypes: "projectTypes",
    }),
  },
  props: {
    details: {
      type: Object,
    },
    ecVisits: {
      type: Array,
    },
  },
  filters: {
    dateFormat: function(value: string) {
      if (!value) return "";
      const options = {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      };
      return new Date(value).toLocaleDateString("en-US", options as any);
    },
  },
  methods: {
    ...mapActions("appModule", ["unmaskCustomerPII"]),
    getTimeDiff: function(date1: Date, date2: Date) {
      return getHumanReadableTimeDifference(date1, date2);
    },
    unmaskCustomer(field: "email" | "phone") {
      this.unmaskCustomerPII({
        pid: this.details.id,
        field,
      });
    },
  },
});
